import React, { useState, useRef, useEffect } from 'react';
import { Row, Col, Card, CardHeader, CardBody, Button, CustomInput, FormFeedback } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faUpload, faSpinner, faCheckCircle, faDownload, faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { put } from '../../helpers/requests';
import auth from '../../helpers/auth';
import { API, BASE_URL } from '../../CONST';
import SafeBtn from '../shared/SafeBtn';
import DownloadBtn from '../shared/DownloadBtn';
import FileUploader from '../shared/FileUploader';
import LibroVentasCierreConfirmacionModal from './LibroVentasCierreConfirmacionModal';
import LibroVentaCargaMasivaModal from './LibroVentaCargaMasivaModal';
import ModalDocumentosTributarios from './DocumentosTributariosModal';

const OperacionesLibrosVenta = () => {
  const [loadingCargaMasiva, setLoadingCargaMasiva] = useState(false);
  const [loadingDocumentosTributarios, setLoadingDocumentosTributarios] = useState(false);
  const [modalCargaMasiva, setModalCargaMasiva] = useState(false);
  const [modalDocumentosTributarios, setModalDocumentosTributarios] = useState(false);
  const [librosCargaMasiva, setLibrosCargaMasiva] = useState([]);
  const [resultadoDocumentosTributarios, setResultadoDocumentosTributarios] = useState({});
  const [fileCargaMasiva, setFileCargaMasiva] = useState({});
  const [fileDocumentosTributarios, setFileDocumentosTributarios] = useState(null);
  const [fileNameDocumentosTributarios, setFileNameDocumentosTributarios] = useState('');
  const [uploadSuccessDocumentosTributarios, setUploadSuccessDocumentosTributarios] = useState(false);
  const [maxSizeError, setMaxSizeError] = useState(false);
  const [fileTypeError, setFileTypeError] = useState(false);
  const [isConfirmOpen, setConfirmOpen] = useState(false);
  const [downloadCallback, setDownloadCallback] = useState(null);
  const [notificationSent, setNotificationSent] = useState(false);
  const fileInputRef = useRef(null);
  const customFileInputRef = useRef(null);
  const POLL_INTERVAL_MS = 5000;
  const PHASE_LABELS = {
    leyendo_archivo: 'Leyendo archivo Excel',
    validando: 'Validando datos',
    guardando_deudores: 'Guardando deudores',
    guardando_documentos: 'Guardando documentos tributarios',
    actualizando_libros: 'Actualizando libros de venta',
    completado: 'Finalizando',
    fusionando_duplicados: 'Buscando y fusionando entradas complicadas'
  };

  const [uploadProgress, setUploadProgress] = useState(null);
  const handleDownloadClick = (callback) => {
    setDownloadCallback(() => callback);
    setConfirmOpen(true);
  };

  const isFileLibroVentasValid = (file) => {
    return file && 
           file instanceof File && 
           file.name && 
           file.size > 0 &&
           (file.name.endsWith('.xls') || file.name.endsWith('.xlsx'));
  };

  const handleSendNotification = async () => {
    if (!resultadoDocumentosTributarios?.poliza_periodos?.length) return false;
    try {
      await auth.fetch(`${BASE_URL}${API.documentoTributario}/send_notification/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ poliza_periodos: resultadoDocumentosTributarios.poliza_periodos }),
      });
      setNotificationSent(true);
      return true;
    } catch (error) {
      console.error('Error al enviar notificación:', error);
      return false;
    }
  };

const parseAuthResponse = async (response) => {
  if (response && typeof response.json === 'function') {
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Error desconocido' }));
      throw new Error(errorData.error || `Error ${response.status}: ${response.statusText}`);
    }
    return await response.json();
  }
  if (response && typeof response === 'object') {
    return response;
  }
  throw new Error('Formato de respuesta inesperado del servidor');
};

const pollUploadStatus = (taskId) => {
  return new Promise((resolve, reject) => {
    const poll = async () => {
      try {
        const res = await auth.fetch(
          `${BASE_URL}${API.documentoTributario}/upload_status/?task_id=${taskId}`
        );
        const data = await parseAuthResponse(res);

        if (data.state === 'PROGRESS') {
          setUploadProgress({ processed: data.processed, total: data.total, phase: data.phase });
          setTimeout(poll, POLL_INTERVAL_MS);
        } else if (data.state === 'PENDING') {
          setTimeout(poll, POLL_INTERVAL_MS);
        } else if (data.state === 'SUCCESS') {
          resolve(data);
        } else if (data.state === 'FAILURE') {
          reject(new Error(data.error || 'La tarea falló durante el procesamiento'));
        } else {
          setTimeout(poll, POLL_INTERVAL_MS);
        }
      } catch (err) {
        reject(err);
      }
    };
    poll();
  });
};



  const handleConfirm = () => {
    if (downloadCallback) {
      downloadCallback();
    }

    put(`${BASE_URL}${API.closeAllLibrosVenta}/`, {})
      .then((response) => {
        console.log('Estados actualizados correctamente:', response);
      })
      .catch((error) => {
        console.error('Error al actualizar los estados:', error);
      });

    setConfirmOpen(false);
  };

  const handleCancel = () => {
    setConfirmOpen(false);
  };

  const validateFileType = (file, accept) => {
    if (!accept) return true;

    const acceptedTypes = accept.split(',').map(type => type.trim());
    const fileExtension = file.name.toLowerCase().substring(file.name.lastIndexOf('.'));

    return acceptedTypes.some((acceptedType) => {
      if (acceptedType.startsWith('.')) {
        return fileExtension === acceptedType.toLowerCase();
      } else if (acceptedType.includes('/')) {
        return file.type === acceptedType;
      } else if (acceptedType.includes('*')) {
        const baseType = acceptedType.split('/')[0];
        return file.type.startsWith(baseType);
      }
      return false;
    });
  };

  const MAX_FILE_SIZE = 100 * 1024 * 1024;
  const handleFileChangeDocumentosTributarios = (e) => {
    const { files } = e.target;
    if (files.length === 0) return;

    let validFile = true;

    if (files[0].size > MAX_FILE_SIZE) {
      setMaxSizeError(true);
      validFile = false;
    }

    if (!validateFileType(files[0], '.xls,.xlsx')) {
      setFileTypeError(true);
      validFile = false;
    }

    if (!validFile) return;

    setMaxSizeError(false);
    setFileTypeError(false);
    setUploadSuccessDocumentosTributarios(false);

    const file = files[0];
    
    if (customFileInputRef && customFileInputRef.current) {
      customFileInputRef.current.labels[0].textContent = file.name;
    }
    
    setFileDocumentosTributarios(file);
    setFileNameDocumentosTributarios(file.name);
  };

const handleUploadDocumentosTributarios = async () => {
  if (!fileDocumentosTributarios) return;

  setLoadingDocumentosTributarios(true);
  setUploadSuccessDocumentosTributarios(false);
  setResultadoDocumentosTributarios(null);
  setUploadProgress(null);
  setNotificationSent(false);

  try {
    const formData = new FormData();
    formData.append('file', fileDocumentosTributarios, fileNameDocumentosTributarios);

    const response = await auth.fetch(`${BASE_URL}${API.documentoTributario}/upload_excel/`, {
      method: 'POST',
      body: formData,
    });

    const { task_id } = await parseAuthResponse(response);
    if (!task_id) {
      throw new Error('El servidor no devolvió un identificador de tarea');
    }

    const result = await pollUploadStatus(task_id);

    setResultadoDocumentosTributarios(result);
    setUploadSuccessDocumentosTributarios(result.success && (!result.warnings || result.warnings.length === 0));
    setModalDocumentosTributarios(true);

  } catch (error) {
    console.error('Error al cargar documentos tributarios:', error);

    setUploadSuccessDocumentosTributarios(false);
    setResultadoDocumentosTributarios({
      success: false,
      error: error.message || 'Error al procesar el archivo',
      errors: [error.message || 'Error al procesar el archivo'],
      created: 0,
      updated: 0,
      total_rows: 0,
    });
    setModalDocumentosTributarios(true);
  } finally {
    setLoadingDocumentosTributarios(false);
    setUploadProgress(null);
  }
};

return (
  <div className="container-fluid py-3">

    <Row className="g-3">
      {/* --- DESCARGA DE LIBROS DE VENTA --- */}
      <Col lg="4" md="6">
        <Card className="shadow-sm h-100 border-0">
          <CardBody className="text-center">
            <div className="mb-3">
              <FontAwesomeIcon icon={faDownload} size="2x" className="text-primary" />
            </div>
            <h6 className="fw-bold mb-3 text-dark">Descarga de Libros</h6>
            <p className="text-muted small mb-3">
              Descargue un resumen consolidado de los libros de venta.<br />
              <FontAwesomeIcon icon={faInfoCircle} className="mr-1 text-info" />
              Cierra los períodos en espera.
            </p>
            <DownloadBtn
              id="cerrarLibros"
              className="btn btn-primary w-100"
              text="Resumen Libros"
              tipText="Descargar resumen consolidado"
              url="/"
              onClick={handleDownloadClick}
            />
          </CardBody>
        </Card>
      </Col>

      {/* --- CARGA MASIVA LIBROS DE VENTA --- */}
      <Col lg="4" md="6">
        <Card className="shadow-sm h-100 border-0">
          <CardBody className="text-center d-flex flex-column justify-content-between">
            <div>
              <FontAwesomeIcon icon={faFileExcel} size="2x" className="text-success mb-3" />
              <h6 className="fw-bold mb-3 text-dark">Carga Masiva de Libros</h6>
              <p className="text-muted small mb-3">
                Los libros cambiarán a estado “Correcto” si cumplen las validaciones.
              </p>

              <div className="mb-3 text-start">
                <CustomInput
                  type="file"
                  id="carga-libros-masiva"
                  name="file-uploader-masiva"
                  label={fileCargaMasiva?.name || 'Seleccionar archivo (.xls, .xlsx)'}
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) setFileCargaMasiva(file);
                  }}
                  accept=".xls,.xlsx"
                  disabled={loadingCargaMasiva}
                />
              </div>
                
              <Button
                color="primary"
                className="w-100"
                onClick={() => {
                  if (!fileCargaMasiva) return;
                  setLoadingCargaMasiva(true);
                  const reader = new FileReader();
                  reader.onload = (e) => {
                    auth.fetch(`${BASE_URL}${API.librosVentaBulkUpload}/`, {
                      method: 'PUT',
                      headers: {
                        'Content-Disposition': `attachment; filename="${fileCargaMasiva.name}"`,
                      },
                      body: e.target.result,
                    })
                      .then((response) => {
                        setLoadingCargaMasiva(false);
                        setModalCargaMasiva(true);
                        setLibrosCargaMasiva(Object.values(response));
                      })
                      .catch(() => setLoadingCargaMasiva(false));
                  };
                  reader.readAsArrayBuffer(fileCargaMasiva);
                }}
                disabled={!isFileLibroVentasValid(fileCargaMasiva) || loadingCargaMasiva}
              >
                {loadingCargaMasiva ? (
                  <>
                    <FontAwesomeIcon icon={faSpinner} spin className="me-2" /> Subiendo...
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon icon={faUpload} className="me-2" /> Subir
                  </>
                )}
              </Button>
            </div>
              
            <div className="mt-3">
              <DownloadBtn
                id="plantilla"
                text="Descargar Plantilla"
                tipText="Descargar plantilla carga masiva"
                className="btn-orsan-primary"
                url="/files/Plantilla_Carga_Masiva_Libros_de_Venta.xlsx"
              />
            </div>
          </CardBody>
        </Card>
      </Col>
              
      {/* --- CARGA DE DOCUMENTOS TRIBUTARIOS --- */}
      <Col lg="4" md="6">
        <Card className="shadow-sm h-100 border-0">
          <CardBody className="text-center d-flex flex-column justify-content-between">
            <div>
              <FontAwesomeIcon icon={faUpload} size="2x" className="text-warning mb-3" />
              <h6 className="fw-bold mb-3 text-dark">Carga de Documentos Tributarios</h6>
              <p className="text-muted small mb-3">
                Suba documentos en formato Excel (.xls, .xlsx)
              </p>
              
              <div className="mb-3 text-start">
                <CustomInput
                  type="file"
                  id="carga-documentos-tributarios"
                  name="file-uploader-documentos"
                  label={fileNameDocumentosTributarios || 'Seleccionar archivo (.xls, .xlsx)'}
                  onChange={handleFileChangeDocumentosTributarios}
                  invalid={maxSizeError || fileTypeError}
                  accept=".xls,.xlsx"
                  disabled={loadingDocumentosTributarios}
                  innerRef={customFileInputRef}
                />
              </div>
              
              <Button
                color="primary"
                className="w-100 text-white"
                onClick={handleUploadDocumentosTributarios}
                disabled={
                  loadingDocumentosTributarios ||
                  uploadSuccessDocumentosTributarios ||
                  !fileDocumentosTributarios
                }
                title={uploadSuccessDocumentosTributarios ? "Archivo subido" : "Subir archivo seleccionado"}
              >
                {loadingDocumentosTributarios ? (
                  <>
                    <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
                    {uploadProgress && uploadProgress.total > 0
                      ? `${PHASE_LABELS[uploadProgress.phase] || 'Procesando'} (${uploadProgress.processed}/${uploadProgress.total})...`
                      : uploadProgress
                        ? `${PHASE_LABELS[uploadProgress.phase] || 'Procesando'}...`
                        : 'Subiendo...'}
                  </>
                ) : uploadSuccessDocumentosTributarios ? (
                  <>
                    <FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Subido
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon icon={faUpload} className="me-2" /> Subir
                  </>
                )}
              </Button>
            </div>
              
            <div className="mt-3">
              <DownloadBtn
                id="plantilla-documentos"
                text="Descargar Plantilla"
                className="btn-orsan-primary"
                tipText="Descargar plantilla documentos tributarios"
                url={`${BASE_URL}${API.documentoTributario}/template_carga_documento_tributario_xlsx/`}
              />
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>

    {/* MODALES */}
    <LibroVentasCierreConfirmacionModal
      isOpen={isConfirmOpen}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
      message='¿Está seguro de que desea continuar? Esta acción cerrará los períodos "En Espera".'
    />

    <LibroVentaCargaMasivaModal
      openModal={modalCargaMasiva}
      toggleModal={() => setModalCargaMasiva(!modalCargaMasiva)}
      libros={librosCargaMasiva}
      fileCargaMasiva={fileCargaMasiva}
    />

    <ModalDocumentosTributarios
      openModal={modalDocumentosTributarios}
      toggleModal={() => setModalDocumentosTributarios(!modalDocumentosTributarios)}
      resultado={resultadoDocumentosTributarios}
      file={fileDocumentosTributarios}
      onSendNotification={handleSendNotification}
      notificationSent={notificationSent}
    />
  </div>
);
}

export default OperacionesLibrosVenta;